/**
 * Semantic status badge tints — map domain statuses onto these five tones
 * before introducing new colors. Sentence / title case labels; never uppercase.
 *
 * Ink: neutral `text-foreground` / `text-secondary-foreground` on washes (same
 * cadence as Badge secondary). Danger keeps chip-destructive ink (Badge destructive).
 */

export type StatusBadgeTone = "success" | "warning" | "info" | "danger" | "neutral"

/** Light washes + neutral ink (Badge secondary cadence); danger = chip-destructive. */
export const STATUS_BADGE_TONE_CLASS: Record<StatusBadgeTone, string> = {
  success:
    "bg-emerald-500/15 text-foreground border-emerald-500/20 dark:bg-emerald-500/15 dark:text-foreground",
  warning:
    "bg-amber-500/15 text-foreground border-amber-500/20 dark:bg-amber-500/15 dark:text-foreground",
  neutral:
    "bg-secondary text-secondary-foreground border-border dark:bg-secondary dark:text-secondary-foreground",
  danger:
    "bg-destructive/15 text-[var(--chip-destructive)] border-destructive/20 dark:bg-destructive/20 dark:text-red-100",
  info:
    "bg-sky-500/15 text-foreground border-sky-500/20 dark:bg-sky-500/15 dark:text-foreground",
}

/** @deprecated Use `STATUS_BADGE_TONE_CLASS.success` */
export const LIST_HUB_STATUS_TINT_SUCCESS = STATUS_BADGE_TONE_CLASS.success
/** @deprecated Use `STATUS_BADGE_TONE_CLASS.warning` */
export const LIST_HUB_STATUS_TINT_WARNING = STATUS_BADGE_TONE_CLASS.warning
/** @deprecated Use `STATUS_BADGE_TONE_CLASS.neutral` */
export const LIST_HUB_STATUS_TINT_NEUTRAL = STATUS_BADGE_TONE_CLASS.neutral
/** @deprecated Use `STATUS_BADGE_TONE_CLASS.danger` */
export const LIST_HUB_STATUS_TINT_DANGER = STATUS_BADGE_TONE_CLASS.danger
/** @deprecated Use `STATUS_BADGE_TONE_CLASS.info` */
export const LIST_HUB_STATUS_TINT_INFO = STATUS_BADGE_TONE_CLASS.info
